import Icon from '@common/assets';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './info.module.scss';
const cx = classnames.bind(styles);

const Info = () => {
  return (
    <div className={cx('infoArea')}>
      <strong className={cx('title')}>
        <Icon name="informationLight" width={32} height={32} />
        응시한 개발자 검사 결과를 통해 내가 보유한 개발 역량을 확인해보세요.
      </strong>

      <ul className={cx('descList')}>
        <li className={cx('descItem')}>
          <Icon name="checkLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
          개발자 역량검사와 개발 구현 능력 검사의 결과표를 확인하실 수 있습니다,
        </li>
        <li className={cx('descItem')}>
          <Icon name="checkLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
          결과 분석은 최대 1일 가량 소요될 수 있습니다. 분석이 완료되면 카카오톡 알림톡으로 메시지를 보내드립니다.
        </li>
        <li className={cx('descItem')}>
          <Icon name="checkLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
          디챔스 결과표 내 개발자 역량검사 결과는 매월 최초 응시 데이터 기준으로만 합산하여 제공됩니다.
        </li>
      </ul>
    </div>
  );
};

export default Info;
